import React from "react";
import PropTypes from "prop-types";

const DetailSection = props => {
	const { title, lines, align, actions, wrapperStyles, wrapperClasses } = props;

	const { lang } = global;

	return (
		<div
			className={`flex flex-direction-column flex-gap-8 ${wrapperClasses || ""}`}
			style={{
				...wrapperStyles,
				...(align === "left" && { marginRight: "auto" }),
				...(align === "right" && { marginLeft: "auto" }),
			}}
		>
			{title && (<strong>{title}</strong>)}
			{lines.length > 0 && lines.map(line => <span>{line}</span>)}
			{actions.map(action => (
				<button
					key={action.label}
					type="button"
					className={`btn ${action.className ? action.className : " btn-link text-left padding-left-0"}`}
					onClick={action.action}
					disabled={action.disabled}
					data-test-id={action.dataTestId}
				>
					{lang.t(action.label)}
				</button>
			))}
		</div>
	);
};

DetailSection.propTypes = {
	title: PropTypes.string.isRequired,
	lines: PropTypes.array.isRequired,
	align: PropTypes.string,
	actions: PropTypes.array,
	wrapperStyles: PropTypes.object,
	wrapperClasses: PropTypes.string,
};

DetailSection.defaultProps = {
	align: "left",
	actions: [],
	wrapperStyles: {},
	wrapperClasses: "",
};

export default DetailSection;
